import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "preloader",
  id: "preloader"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [_createElementVNode("span", null, null, -1), _createElementVNode("span", null, null, -1), _createElementVNode("span", null, null, -1), _createElementVNode("span", null, null, -1), _createElementVNode("span", null, null, -1)]));
}